@use "variables" as *;

.container {
  position: relative;
  width: 100%;
  display: flex;
}

.name {
  width: 85%;
  font-size: $fontSize-s;
  flex-shrink: 0;
  font-variant: tabular-nums;
}

.boxSet {
  width: 15%;
  font-size: $fontSize-xxs;
  font-weight: bold;
  text-align: center;
  flex-shrink: 0;
  font-variant: tabular-nums;
  white-space: pre-wrap;
  text-transform: uppercase;
}
